// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-max[data-v-ff0f4c94]{max-height:80vh}.survey[data-v-ff0f4c94]{margin-top:2rem;width:100%}", ""]);
// Exports
module.exports = exports;
